export const closeModal = (modalId) => {
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
        modalElement.classList.remove('show');
        modalElement.style.display = 'none';
    }

    document.body.classList.remove('modal-open');

    const backdrop = document.getElementsByClassName('modal-backdrop')[0];
    if (backdrop) {
        backdrop.parentNode.removeChild(backdrop);
    }

    // Reset scroll position
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
};